export var MPARequestListPerspective;
(function (MPARequestListPerspective) {
    MPARequestListPerspective["MPA_REQUEST_LIST_PERSPECTIVE_UNSPECIFIED"] = "MPA_REQUEST_LIST_PERSPECTIVE_UNSPECIFIED";
    MPARequestListPerspective["MPA_REQUEST_LIST_PERSPECTIVE_REQUESTER"] = "MPA_REQUEST_LIST_PERSPECTIVE_REQUESTER";
    MPARequestListPerspective["MPA_REQUEST_LIST_PERSPECTIVE_REVIEWER"] = "MPA_REQUEST_LIST_PERSPECTIVE_REVIEWER";
})(MPARequestListPerspective || (MPARequestListPerspective = {}));
